import { useIntersectionObserver, useThrottledCallback } from "@react-hookz/web";
import { useCallback, useEffect, useState } from "react";
export const useTrackImpressionEventByIntersection = parameters => {
  const {
    ga4TrackingHandler,
    gaTrackingHandler,
    getEvent,
    getGa4Event,
    options
  } = parameters;
  const [targetElement, setTargetElement] = useState(null);
  const [hasSent, setHasSent] = useState(false);
  const shouldSend = options !== null && options !== void 0 && options.shouldSendOnce ? !hasSent : true;
  const intersection = useIntersectionObserver(shouldSend && (getEvent || getGa4Event) ? targetElement : null, {
    threshold: options === null || options === void 0 ? void 0 : options.intersectionThreshold
  });
  const handleSend = useThrottledCallback((event, ga4Event) => {
    if (options !== null && options !== void 0 && options.isSendGATracking && event && gaTrackingHandler) {
      gaTrackingHandler(event);
    }
    if (options !== null && options !== void 0 && options.isSendGA4Tracking && ga4Event && ga4TrackingHandler) {
      ga4TrackingHandler(ga4Event);
    }
    setHasSent(true);
  }, [gaTrackingHandler, ga4TrackingHandler, setHasSent], options !== null && options !== void 0 && options.shouldThrottle ? 300 : 0, true);
  useEffect(() => {
    if (!shouldSend || !(intersection !== null && intersection !== void 0 && intersection.isIntersecting) || !getEvent && !getGa4Event) return;
    handleSend(getEvent ? getEvent() : null, getGa4Event ? getGa4Event() : null);
  }, [getEvent, getGa4Event, shouldSend, intersection === null || intersection === void 0 ? void 0 : intersection.isIntersecting, handleSend]);
  useEffect(() => {
    setHasSent(false);
  }, [targetElement]);
  const captureTrackImpressionEventTargetElement = useCallback(element => {
    setTargetElement(element);
  }, [setTargetElement]);
  return {
    captureTrackImpressionEventTargetElement,
    intersection
  };
};